<section class="data-table" [attr.aria-label]="ariaLabel">
	<div class="data-table__desktop" *ngIf="columns.length > 0">
		<div class="data-table__scroll">
			<table class="data-table__table">
				<thead>
					<tr>
						<th *ngFor="let column of columns; trackBy: trackByColumn" scope="col" [style.width]="column.width">
							<ng-container *ngIf="isSorting; else staticHeader">
								<button
									type="button"
									class="data-table__sort-trigger"
									(click)="onSort(column)"
									[attr.aria-label]="(column.header || column.key) + ' ' + getSortLabel(column)"
								>
									<span>{{ column.header }}</span>
									<span
										class="data-table__sort-icon"
										[class.data-table__sort-icon--asc]="getSortDirectionFor(column) === 'asc'"
										[class.data-table__sort-icon--desc]="getSortDirectionFor(column) === 'desc'"
										[class.data-table__sort-icon--none]="getSortDirectionFor(column) === null"
										aria-hidden="true"
									></span>
								</button>
							</ng-container>
							<ng-template #staticHeader>{{ column.header }}</ng-template>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngIf="rows.length === 0">
						<td class="data-table__empty" [attr.colspan]="columns.length">{{ emptyMessage }}</td>
					</tr>
					<tr *ngFor="let row of rows; let rowIndex = index; trackBy: trackByRow">
						<td *ngFor="let column of columns; trackBy: trackByColumn" [style.width]="column.width">
							<ng-container *ngIf="isStatusColumn(column); else defaultDesktopCell">
								<button type="button" class="data-table__status-button"
								(click)="goToReviewOrder(row)"
								[disabled]="isLoadingReviewOrder || !getResolvedStatus(row[column.key]).active"
								[class.data-table__status-button--loading]="isLoadingReviewOrder"
								[class.data-table__status-button--disabled]="!getResolvedStatus(row[column.key]).active"
								aria-label="Open order review page">
									<span
										class="data-table__status"
										[class.data-table__status--active]="getResolvedStatus(row[column.key]).active"
										[class.data-table__status--inactive]="!getResolvedStatus(row[column.key]).active"
									>
										<span
											class="data-table__status-icon"
											[class.data-table__status-icon--caution]="getResolvedStatus(row[column.key]).kind === 'caution'"
											[class.data-table__status-icon--positive]="getResolvedStatus(row[column.key]).kind === 'positive'"
											[class.data-table__status-icon--negative]="getResolvedStatus(row[column.key]).kind === 'negative'"
											aria-hidden="true"
										></span>
										{{ getResolvedStatus(row[column.key]).text }}
										<span class="data-table__arrow-icon"></span>
									</span>
								</button>
							</ng-container>
							<ng-template #defaultDesktopCell>
								{{ getCellValue(row, column.key) }}
							</ng-template>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="data-table__mobile" *ngIf="columns.length > 0">
		<ng-container *ngIf="rows.length > 0; else mobileEmptyState">
			<article class="data-table__card" *ngFor="let row of rows; let rowIndex = index; trackBy: trackByRow">
				<div class="data-table__field" *ngFor="let column of columns; trackBy: trackByColumn">
					<p class="data-table__label">{{ column.header }}</p>
					<p class="data-table__value" *ngIf="!isStatusColumn(column)">{{ getCellValue(row, column.key) }}</p>
					<div class="data-table__value" *ngIf="isStatusColumn(column)">
						<button type="button" class="data-table__status-button"
								(click)="goToReviewOrder(row)"
								[disabled]="isLoadingReviewOrder || !getResolvedStatus(row[column.key]).active"
								[class.data-table__status-button--loading]="isLoadingReviewOrder"
								[class.data-table__status-button--disabled]="!getResolvedStatus(row[column.key]).active"
								aria-label="Open order review page">
							<span
								class="data-table__status"
								[class.data-table__status--active]="getResolvedStatus(row[column.key]).active"
								[class.data-table__status--inactive]="!getResolvedStatus(row[column.key]).active"
							>
								<span
									class="data-table__status-icon"
									[class.data-table__status-icon--caution]="getResolvedStatus(row[column.key]).kind === 'caution'"
									[class.data-table__status-icon--positive]="getResolvedStatus(row[column.key]).kind === 'positive'"
									[class.data-table__status-icon--negative]="getResolvedStatus(row[column.key]).kind === 'negative'"
									aria-hidden="true"
								></span>
								{{ getResolvedStatus(row[column.key]).text }}
								<span class="data-table__arrow-icon"></span>
							</span>
						</button>
					</div>
				</div>
			</article>
		</ng-container>

		<ng-template #mobileEmptyState>
			<div class="data-table__mobile-empty">{{ emptyMessage }}</div>
		</ng-template>
	</div>
</section>
